/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ExternalEmployerSearchOrderBy,
    ExternalEmployerSearchOrderByFromJSON,
    ExternalEmployerSearchOrderByToJSON,
} from '../models/ExternalEmployerSearchOrderBy';
import {
    type ExternalUserEmployerSearchResponsePagedResult,
    ExternalUserEmployerSearchResponsePagedResultFromJSON,
    ExternalUserEmployerSearchResponsePagedResultToJSON,
} from '../models/ExternalUserEmployerSearchResponsePagedResult';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiExternalUserEmployerSearchGetRequest {
    name?: string;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: ExternalEmployerSearchOrderBy;
}

/**
 * 
 */
export class ExternalUserEmployerApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiExternalUserEmployerSearchGet without sending the request
     */
    async apiExternalUserEmployerSearchGetRequestOpts(requestParameters: ApiExternalUserEmployerSearchGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['Name'] = requestParameters['name'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/external-user-employer/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiExternalUserEmployerSearchGetRaw(requestParameters: ApiExternalUserEmployerSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserEmployerSearchResponsePagedResult>> {
        const requestOptions = await this.apiExternalUserEmployerSearchGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserEmployerSearchResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiExternalUserEmployerSearchGet(requestParameters: ApiExternalUserEmployerSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserEmployerSearchResponsePagedResult> {
        const response = await this.apiExternalUserEmployerSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
